export default "__VITE_ASSET__vrfH50OxkFdi7Fu$IQvsPw__"